import React from 'react';
import { Server, Smartphone, Database, Shield, ChevronRight, QrCode, Copy, Trash2 } from 'lucide-react';
export function SettingsPage() {
  return <div className="p-4 pb-20 space-y-6" data-id="element-220">
      <h1 className="text-2xl font-bold text-white" data-id="element-221">Settings</h1>

      {/* Server Config */}
      <section data-id="element-222">
        <h2 className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-3 ml-1" data-id="element-223">
          Server Configuration
        </h2>
        <div className="bg-slate-800 rounded-xl overflow-hidden border border-slate-700" data-id="element-224">
          <div className="p-4 flex items-center justify-between border-b border-slate-700" data-id="element-225">
            <div className="flex items-center space-x-3" data-id="element-226">
              <div className="p-2 bg-blue-500/10 text-blue-400 rounded-lg" data-id="element-227">
                <Server size={20} data-id="element-228" />
              </div>
              <div data-id="element-229">
                <div className="text-white font-medium" data-id="element-230">Server URL</div>
                <div className="text-slate-400 text-xs" data-id="element-231">
                  https://api.attendance.company.com
                </div>
              </div>
            </div>
            <button className="p-2 text-slate-400 hover:text-white" data-id="element-232">
              <QrCode size={20} data-id="element-233" />
            </button>
          </div>
          <button className="w-full p-3 text-sm text-blue-400 font-medium hover:bg-slate-700/50 transition-colors" data-id="element-234">
            Test Connection
          </button>
        </div>
      </section>

      {/* Device Info */}
      <section data-id="element-235">
        <h2 className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-3 ml-1" data-id="element-236">
          Device Information
        </h2>
        <div className="bg-slate-800 rounded-xl overflow-hidden border border-slate-700" data-id="element-237">
          <div className="p-4 flex items-center justify-between border-b border-slate-700" data-id="element-238">
            <div className="flex items-center space-x-3" data-id="element-239">
              <div className="p-2 bg-purple-500/10 text-purple-400 rounded-lg" data-id="element-240">
                <Smartphone size={20} data-id="element-241" />
              </div>
              <div data-id="element-242">
                <div className="text-white font-medium" data-id="element-243">Device ID</div>
                <div className="text-slate-400 text-xs font-mono" data-id="element-244">
                  DEV-8839-AC21
                </div>
              </div>
            </div>
            <button className="p-2 text-slate-400 hover:text-white" data-id="element-245">
              <Copy size={20} data-id="element-246" />
            </button>
          </div>
          <div className="p-4 flex items-center justify-between" data-id="element-247">
            <div className="text-slate-400 text-sm" data-id="element-248">App Version</div>
            <div className="text-white font-mono text-sm" data-id="element-249">
              v2.4.1 (Build 892)
            </div>
          </div>
        </div>
      </section>

      {/* Data Management */}
      <section data-id="element-250">
        <h2 className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-3 ml-1" data-id="element-251">
          Data Management
        </h2>
        <div className="bg-slate-800 rounded-xl overflow-hidden border border-slate-700 divide-y divide-slate-700" data-id="element-252">
          <button className="w-full p-4 flex items-center justify-between hover:bg-slate-700/50 transition-colors" data-id="element-253">
            <div className="flex items-center space-x-3" data-id="element-254">
              <Database size={20} className="text-slate-400" data-id="element-255" />
              <span className="text-white" data-id="element-256">Export All Logs</span>
            </div>
            <ChevronRight size={16} className="text-slate-500" data-id="element-257" />
          </button>
          <button className="w-full p-4 flex items-center justify-between hover:bg-slate-700/50 transition-colors" data-id="element-258">
            <div className="flex items-center space-x-3" data-id="element-259">
              <Trash2 size={20} className="text-red-400" data-id="element-260" />
              <span className="text-red-400" data-id="element-261">Clear Local Cache</span>
            </div>
          </button>
        </div>
      </section>

      {/* Security */}
      <section data-id="element-262">
        <h2 className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-3 ml-1" data-id="element-263">
          Security
        </h2>
        <div className="bg-slate-800 rounded-xl overflow-hidden border border-slate-700" data-id="element-264">
          <button className="w-full p-4 flex items-center justify-between hover:bg-slate-700/50 transition-colors" data-id="element-265">
            <div className="flex items-center space-x-3" data-id="element-266">
              <Shield size={20} className="text-slate-400" data-id="element-267" />
              <span className="text-white" data-id="element-268">Admin PIN</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-269">
              <span className="text-slate-500 text-sm" data-id="element-270">Enabled</span>
              <ChevronRight size={16} className="text-slate-500" data-id="element-271" />
            </div>
          </button>
        </div>
      </section>
    </div>;
}